import { render } from "./WiseCountrySelector.vue?vue&type=template&id=45aa2985&scoped=true"
import script from "./WiseCountrySelector.vue?vue&type=script&lang=js"
export * from "./WiseCountrySelector.vue?vue&type=script&lang=js"

import "./WiseCountrySelector.vue?vue&type=style&index=0&id=45aa2985&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45aa2985"]])

export default __exports__